exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-procedure .sb-reference-values-table div.refrence-value-cell{margin-top:8px;padding:8px;background-color:rgba(0,0,0,.08)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/procedure/procedure.scss
// module id = 653
// module chunks = 0